import { getLoadingMessage } from '../../shared/utils';

const defaultState = {
  name: '',
  emailVerified: true,
  fullStorage: [],
  totalsubmissions: 0,
  submissionsUsed: 0,
  submissionsLeft: 0,
  formsCount: 0,
  formViewsUsed: 0,
  formsLeft: Infinity,
  recentForms: [],
  loading: true,
  loadingInfo: true,
  planIconType: '',
  dayDifference: 0,
  prettyTrialExpiry: '',
  categories: {},
  parentCategory: {},
  templates: [],
  submissionMetric: {},
  message: getLoadingMessage(),
  useCase: '',
  industry: '',
  created: '',
  subscriptionRenew: '',
  membersMax: 0,
  membersCount: 0,
  loadingQuota: true,
  loadingSubscription: true,
  loadingFormData: true,
  useDatastore: false,
  storageLimit: 0,
  storageUsed: 0,
  maxFormView: 0,
  subscriptionStatus: 'active', //  TODO: When pause feature is ready
  isReactivatingSubscription: false,
};

export default function dashboardReducers(state = defaultState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'FETCH_QUOTA': {
      return { ...state, ...payload };
    }

    case 'FETCH_USERINFO': {
      if (!payload.useCase) {
        payload.useCase = state.useCase;
      }
      return { ...state, ...payload };
    }

    case 'FETCH_USERINFO_ANALYTICS': {
      return { ...state, ...payload };
    }

    case 'FETCH_FORM_DATA': {
      return { ...state, ...payload };
    }

    case 'FETCH_SUBSCRIPTION_INFO': {
      return { ...state, ...payload };
    }

    case 'FETCH_FORM_TEMPLATES': {
      return { ...state, ...payload };
    }

    case 'UPGRADE_PLAN_SUCCESS': {
      return { ...state, ...payload };
    }

    case 'REACTIVATE_SUBSCRIPTION': {
      return { ...state, ...payload };
    }

    default: {
      return state;
    }
  }
}
